export enum AlternateNotificationPreferencesEnum {
        Call = 5155,
        Email = 5156,
        Pager = 5157,
        Text = 5158,
        MobileApp = 5168,
        Fax = 5169,
}
